/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Note_Error_No_AudioInputs */

const en_toast_note_error_no_audio = /** @type {(inputs: Toast_Note_Error_No_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error adding audio note, no playing audio`)
};

const es_toast_note_error_no_audio = /** @type {(inputs: Toast_Note_Error_No_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al agregar nota de audio, no hay audio reproduciéndose`)
};

/**
* | output |
* | --- |
* | "Error adding audio note, no playing audio" |
*
* @param {Toast_Note_Error_No_AudioInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const toast_note_error_no_audio = /** @type {((inputs?: Toast_Note_Error_No_AudioInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Note_Error_No_AudioInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_toast_note_error_no_audio(inputs)
	return en_toast_note_error_no_audio(inputs)
});